import { SalesOrderType } from '../constants/sales-order-type.js';
/**
 * Derives which Temporal path an order is running from its stored fields — there's no
 * dedicated column for it. Drop Ship reads off `typeId`; Credit Return has no distinct
 * `sales_order_type` row (see `createSalesOrder`'s `customFields` marker), so it's read from
 * there instead. Anything else is Standard.
 */
export function salesOrderPathFromOrder(order) {
    if (order.typeId === SalesOrderType.DROP_SHIP)
        return 'DropShip';
    const customFields = typeof order.customFields === 'object' &&
        order.customFields !== null &&
        !Array.isArray(order.customFields)
        ? order.customFields
        : null;
    if (customFields?.orderType === 'CreditReturn')
        return 'CreditReturn';
    return 'Standard';
}
//# sourceMappingURL=sales-order-path-from-order.js.map